module.exports = __webpack_public_path__ + "static/img_0854-3ce416524e3187f3391489c2ec19e7c9.webp";